import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import {
  SET_TOKEN,
} from './constants';

const initialState = fromJS({
  token: null,
});

export default handleActions({
  [SET_TOKEN]: (state: any, { payload }) => state.set('token', payload.token),
}, initialState);
